import { QueryClient } from '@tanstack/react-query';
import { staleTimes } from './theme';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: staleTimes.standard,
      refetchOnWindowFocus: true,
      retry: 1,
      // Keep inactive queries for 24h so the persisted (IndexedDB) cache survives a navigate-away and a
      // reload — must be >= the persister's maxAge or the game lists get GC'd before they can restore.
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
});